import React from 'react';
import {useSelector} from 'react-redux';
import {usePresentationThemeDetailQuery} from '../../../hooks/usePresentationThemeDetailQuery';
import {selectedPresentationSelector} from '../../../store/selectors/presentation.selectors';

interface FavoriteColorsListProps {
    colorToSelect: string | null;
    setColorToSelect: (color: string) => void;
}

function FavoriteColorsList(props: FavoriteColorsListProps): JSX.Element {
    const {colorToSelect, setColorToSelect} = props;
    const presentation = useSelector(selectedPresentationSelector);
    const {data: theme} = usePresentationThemeDetailQuery(presentation.presentationThemeId);

    return (
        <div className="u-flex u-mt-2">
            {presentation.presentationThemeId &&
                theme?.favoriteColors?.map((colorCode, index) => {
                    const keyIndex = `color-${colorCode}-${index}-inner`;

                    return (
                        <div
                            key={keyIndex}
                            onClick={(e) => {
                                e.preventDefault();
                                setColorToSelect(colorCode || '');
                            }}
                            className="c-colorPicker__color"
                        >
                            <div
                                key={`c-colorPicker-${index}`}
                                className={`c-colorPicker__color ${colorCode === colorToSelect ? 'is-active' : ''}`}
                                style={{backgroundColor: colorCode}}
                            />
                        </div>
                    );
                })}
        </div>
    );
}

export default FavoriteColorsList;
